import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { ParameterGroupSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/requests/ParameterGroupSaveRequestDTO'
import { ParameterGroupSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/requests/ParameterGroupSearchRequestDTO'
import { ParameterGroupFieldsRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/requests/ParameterGroupFieldsRequestDTO'
import { ParameterGroupResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/responses/ParameterGroupResponseDTO'

export class ParameterGroupRequests {

	public static CONTROLLER_ROOT = 'parameter-group'
	public static SEARCH_EP = 'search'
	public static GET_EP = 'get/:code'
	public static SAVE_EP = 'save'
	public static UPDATE_EP = 'update/:code'
	public static DELETE_EP = 'delete/:code'
	public static ADD_FIELDS_EP = 'add-fields/:code'
	public static REMOVE_FIELD_EP = 'remove-field/:code/:fieldCode'
	public static FIELDS_EP = 'fields/:code'

	static search = (dto: ParameterGroupSearchRequestDTO): RequestConfigTP<ParameterGroupResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.SEARCH_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

	static get = (code: number): RequestConfigTP<ParameterGroupResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.GET_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

	static create = (dto: ParameterGroupSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.SAVE_EP}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static update = (code: number, dto: ParameterGroupSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.UPDATE_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.PUT,
		params: dto,
	})

	static delete = (code: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.DELETE_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.DELETE,
	})

	static addFields = (code: number, dto: ParameterGroupFieldsRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.ADD_FIELDS_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static removeField = (code: number, fieldCode: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.REMOVE_FIELD_EP
			.replace(':code', code.toString())
			.replace(':fieldCode', fieldCode.toString())}`,
		method: HttpMethodEnum.DELETE,
	})

	static getFields = (code: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${ParameterGroupRequests.CONTROLLER_ROOT}/${ParameterGroupRequests.FIELDS_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

}
